import { Pipe, PipeTransform } from '@angular/core';
@Pipe({  name: 'splitTextByComma', pure: false })
export class SplitTextByCommaPipe implements PipeTransform {

  transform(text: string, args?: any): any {
    //console.log('args', args)
    const emailList: string[] = text.split(',');
    if (emailList.length <= 2) {
      return text;
    } else {
      return emailList.slice(0, 2).join(',').concat('...');
    }
  }

 }
